<script lang="ts">
	import type { WithElementRef } from 'bits-ui'
	import type { HTMLAttributes } from 'svelte/elements'
	import { cn } from 'tailwind-variants'

	let {
		ref = $bindable(null),
		class: className,
		children,
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLDivElement>> = $props()
</script>

<div
	bind:this={ref}
	class={cn('bg-muted/50 flex items-center rounded-b-xl border-t p-(--card-spacing)', className)}
	data-slot="card-footer"
	{...restProps}
>
	{@render children?.()}
</div>
